import { render, staticRenderFns } from "./MediaListItemDeleteAction.vue?vue&type=template&id=22a85602"
import script from "./MediaListItemDeleteAction.vue?vue&type=script&lang=js"
export * from "./MediaListItemDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports